import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
    formRoot: {
        display: 'flex',
        flexDirection: 'column',
        padding: '10px !important',
        minWidth:'500px !important'
    },
    submitBtn: {
        display: 'flex',
        flexDirection:'row'
    },
    bannerDiv: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        minWidth: '400px'
    },
    imageContainer: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '15px',
        alignItems: 'start',
        minWidth: '500px',
        justifyContent: 'space-between'
    },

    formElements: {
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid red'
    },
    formError: {
        paddingTop: '0 !important',
        fontSize: '11px',
        color: '#e83833'
    },
    listItems: {
        display: 'flex',
        marginBottom: '12px',
        minWidth: '600px',
        '& div': {
            marginRight:"5px"
        }
    },
    subOptions: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    }
}));